import { useFilter } from './InvoiceFilterContext';
import { useOrdersFilter } from './OrdersFilterContext';
import { useQuotesFilter } from './QuotesFilterContext';
export function useAllFilters() {
    const { filters: invoice } = useFilter();
    const { filters: orders } = useOrdersFilter();
    const { filters: quotes } = useQuotesFilter();

    return { invoice, orders, quotes };
}
